import {usageSchema} from '../common/UsageSchema';

/**
 * Response schema for single usage record
 */
export const getUsageResponseSchema = usageSchema;
